import { useMemo as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import { useTranslation as n } from "react-i18next";
var r = { articleFooterWrapper: "_articleFooterWrapper_wqr7e_1" }, i = {
	Facebook: (e) => /* @__PURE__ */ t("svg", {
		...e,
		fill: "none",
		height: "37",
		viewBox: "0 0 37 37",
		width: "37",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ t("path", {
			clipRule: "evenodd",
			d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37ZM20.6249 11.6832L22.5288 11.6825V8.3294L19.7544 8.325C17.0092 8.325 15.1297 10.0009 15.1297 13.0778V15.7292H12.025V19.3249H15.1297V28.5513H18.843V19.3249H22.4021L22.4031 15.7292H18.843V13.4336C18.843 12.3927 19.1324 11.6832 20.6249 11.6832Z",
			fill: "#9CAEBD",
			fillRule: "evenodd"
		})
	}),
	X: (e) => /* @__PURE__ */ t("svg", {
		...e,
		fill: "none",
		height: "37",
		viewBox: "0 0 37 37",
		width: "37",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ t("path", {
			clipRule: "evenodd",
			d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37ZM29.5897 7.4L20.7587 17.193L30.359 30.525H23.2958L16.8287 21.5453L8.73295 30.525H6.64103L15.9013 20.2568L6.64103 7.4H13.7042L19.8266 15.9014L27.4978 7.4H29.5897ZM12.7018 8.90495H9.48797L24.2816 29.094H27.4962L12.7018 8.90495Z",
			fill: "#9DAFBD",
			fillRule: "evenodd"
		})
	}),
	Instagram: (e) => /* @__PURE__ */ t("svg", {
		...e,
		fill: "none",
		height: "37",
		viewBox: "0 0 37 37",
		width: "37",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ t("path", {
			clipRule: "evenodd",
			d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37ZM24.0025 30.525H13.5668C10.1665 30.525 7.39999 27.7156 7.39999 24.2619V13.6631C7.39999 10.2094 10.1665 7.4 13.5668 7.4H24.0025C27.403 7.4 30.1692 10.2094 30.1692 13.6631V24.2622C30.1692 27.7156 27.403 30.525 24.0025 30.525ZM13.5668 9.32718C11.2127 9.32718 9.29752 11.2723 9.29752 13.6631V24.2622C9.29752 26.653 11.2127 28.5981 13.5668 28.5981H24.0025C26.3565 28.5981 28.2717 26.653 28.2717 24.2622V13.6631C28.2717 11.2723 26.3565 9.32718 24.0025 9.32718H13.5668ZM18.9744 24.7437C15.8356 24.7437 13.2821 22.15 13.2821 18.9625C13.2821 15.7744 15.8356 13.1812 18.9744 13.1812C22.1131 13.1812 24.6667 15.7744 24.6667 18.9625C24.6667 22.15 22.1131 24.7437 18.9744 24.7437ZM18.9744 15.1084C16.8819 15.1084 15.1796 16.8373 15.1796 18.9625C15.1796 21.088 16.8819 22.8166 18.9744 22.8166C21.0669 22.8166 22.7691 21.088 22.7691 18.9625C22.7691 16.8373 21.0671 15.1084 18.9744 15.1084ZM26.3268 12.8199C26.3268 13.5516 25.7428 14.1447 25.0224 14.1447C24.302 14.1447 23.718 13.5516 23.718 12.8199C23.718 12.0883 24.302 11.4951 25.0224 11.4951C25.7428 11.4951 26.3268 12.0883 26.3268 12.8199Z",
			fill: "#9DAFBD",
			fillRule: "evenodd"
		})
	}),
	ClipboardLink: (e) => /* @__PURE__ */ t("svg", {
		...e,
		fill: "none",
		height: "37",
		viewBox: "0 0 37 37",
		width: "37",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ t("path", {
			clipRule: "evenodd",
			d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37ZM8.87595 28.5218C10.8431 30.4892 14.0526 30.4892 16.02 28.5218L20.262 24.2799C20.4432 24.103 20.5461 23.861 20.5478 23.6077C20.5494 23.3544 20.4494 23.1111 20.2703 22.932C20.0913 22.753 19.8479 22.653 19.5947 22.6545C19.3414 22.6563 19.0991 22.7591 18.9223 22.9404L14.6807 27.1824C13.4322 28.4307 11.464 28.4307 10.2156 27.1824C8.96707 25.9341 8.96707 23.9658 10.2156 22.7173L14.6807 18.2522C15.8714 17.0616 17.7158 17.0105 18.9644 18.0848C19.2223 18.3053 19.5784 18.3715 19.8984 18.2583C20.2184 18.1454 20.4538 17.8701 20.5159 17.5364C20.5778 17.2025 20.4571 16.8611 20.1992 16.6404C18.2153 14.9336 15.2166 15.0371 13.341 16.9127L8.87595 21.3777C6.90854 23.3451 6.90854 26.5544 8.87595 28.5218ZM17.1989 20.7569C19.1828 22.4638 22.1815 22.3602 24.0571 20.4847L28.5222 16.0195C30.4896 14.0524 30.4896 10.8429 28.5222 8.87546C26.555 6.90805 23.3455 6.90805 21.3781 8.87546L17.1364 13.1172C16.9547 13.2941 16.8512 13.5364 16.8494 13.7899C16.8476 14.0433 16.9476 14.2871 17.1269 14.4664C17.3062 14.6457 17.5498 14.7455 17.8035 14.7437C18.057 14.7419 18.2992 14.6387 18.4759 14.4567L22.7176 10.215C23.9661 8.96664 25.9344 8.96664 27.1827 10.215C28.4313 11.4635 28.4313 13.4315 27.1827 14.6801L22.7176 19.1452C21.527 20.3357 19.6825 20.3867 18.434 19.3125C18.2426 19.1476 17.9935 19.0654 17.7416 19.0846C17.4896 19.1038 17.2555 19.2225 17.0914 19.4145C16.9271 19.6066 16.8463 19.8561 16.8664 20.108C16.8866 20.36 17.0064 20.5935 17.1991 20.7569H17.1989Z",
			fill: "#9DAFBD",
			fillRule: "evenodd"
		})
	})
}, a = (e) => e.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(""), o = (o) => {
	let { t: s } = n(["label"]), c = (e) => {
		e.preventDefault();
		let t = window.location.href;
		navigator.clipboard.writeText(t).then(() => {
			console.log("Link copied!", t);
		}).catch((e) => {
			console.error("Failed to copy link: ", e);
		});
	}, l = e(() => o.socials.map((e, n) => {
		let r = s(`CX_SOCIAL_${e.platform.toUpperCase()}_ACCOUNT`), o = i[a(e.platform)];
		return /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t("a", {
			"data-testid": `platform-${e.platform}`,
			href: r.length !== 0 && e.platform !== "clipboard_link" ? r : "#",
			onClick: e.platform === "clipboard_link" ? c : void 0,
			rel: "noopener noreferrer",
			target: "_blank",
			children: /* @__PURE__ */ t(o, {})
		}) }, n);
	}), [o.socials, s]);
	return /* @__PURE__ */ t("div", {
		className: r.articleFooterWrapper,
		"data-testid": "article-footer-div",
		children: l
	});
}, s = o;
//#endregion
export { o as ArticleFooter, s as default };
